export default {
	tabs: {
		user: "Benutzereinstellungen",
		customer: "Kundenkonto",
		delivery: "Lieferadressen",
		invoice: "Rechnungsadressen",
	},
};
